<template>
  <div>
    <add-country :is-active.sync="isAdding" @changed="countryAdded" />
    <data-table
      title="Transfer Countries"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Country
        </v-btn>
      </template>
      <template slot="item.currency" slot-scope="{ item }">
        {{ item.currency && item.currency.code ? item.currency.code : 'N/A' }}
      </template>

      <template slot="item.exchange_rate" slot-scope="{ item }">
        {{ item.currency && item.currency.exchange_rate ? item.currency.exchange_rate : 'N/A' }}
      </template>
      <template slot="item.is_sending_country" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_sending_country">
          mdi-progress-check
        </v-icon>
        <v-icon color="error" v-else>
          mdi-progress-close
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCountry from "./form";

export default {
  components: { AddCountry },
  data() {
    return {
      isAdding: false,
      url: "/api/v1/transactions/transferCountries",
      headers: {
        name: "Name",
        sending_min_amount: "Sending Min Amount",
        sending_max_amount: "Sending Max Amount",
        receiving_min_amount: "Receiving Min Amount",
        receiving_max_amount: "Receiving Max Amount",
        risk_level: "Risk level",
        continent: "Continent",
        currency: "Currency",
        exchange_rate: "Euro exchange rate", 
        is_sending_country: "Is Sending Country",
      },
      fields: {
        sending_min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        sending_max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        receiving_min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        receiving_max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        continent: {
          format: (value) => {
            return value.charAt(0).toUpperCase() + value.slice(1);
          },
        },
        risk_level: {
          format: (value) => {
            return value.charAt(0).toUpperCase() + value.slice(1);
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    countryAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails({ id }) {
      this.$router.push({ name: "platform.countries.show", params: { id } });
    },
  },
};
</script>
